import { cn } from 'utils/styles';

interface ArticleTagProps {
  label: string;
  className?: string;
}

export const ArticleTag = ({ label, className }: ArticleTagProps) => (
  <p className={cn('w-fit font-serif font-normal text-base px-2 py-1 border border-current rounded-sm', className)}>
    {label}
  </p>
);
